import { useQuery } from "@tanstack/react-query";
import InfoFaqService from "../services/api/info/InfoFaq.service";
import { RefreshReactQuery } from "../constants/AppConstants";
import { useNotification } from "./notification.hook";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";
import { useEffect } from "react";

export const useFaq = () => {
  const { notification } = useNotification();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["get-faqs"],
    queryFn: () => InfoFaqService.list(),
    staleTime: RefreshReactQuery.INFINITY,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isLoading };
};
